import React from 'react';
import { withTranslation } from 'react-i18next';

import logo from 'images/nifty-logo.svg';

import './PoweredBy.styles.scss';

const PoweredBy = ({ t }) => (
    <a href="https://niftypm.com" target="_blank" rel="noreferrer" className="powered-by">
        { t('Powered by', { name: ''}) }

        <img src={logo} alt="Nifty Logo" width={64} />
    </a>
)

export default withTranslation('common')(PoweredBy);
